import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export interface EmptyStateProps {
  title: string
  description?: ReactNode
  /** Przycisk akcji albo link. */
  action?: ReactNode
  icon?: ReactNode
  /** 'inline' — wewnątrz karty/tabeli, 'page' — pusty widok strony. */
  size?: 'inline' | 'page'
  className?: string
}

/** Stan pusty — używany zamiast pustych list i tabel. */
export function EmptyState({ title, description, action, icon, size = 'inline', className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        size === 'page' ? 'gap-2 px-6 py-20' : 'gap-1.5 px-6 py-10',
        className,
      )}
    >
      {icon ? <div className="mb-1 text-muted opacity-60">{icon}</div> : <DefaultMark />}
      <p className={cn(size === 'page' ? 't-h2' : 'text-base font-medium text-ink')}>{title}</p>
      {description ? <p className="max-w-[52ch] text-small text-muted">{description}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  )
}

function DefaultMark() {
  return (
    <svg aria-hidden viewBox="0 0 32 32" className="mb-1 h-6 w-6 text-[#c3cdd5]">
      <rect x="5.5" y="3.5" width="21" height="25" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path d="M10 11h12M10 16h12M10 21h7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  )
}
